var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.proxima_etapa)?_c('div',{attrs:{"data-anima":"bottom"}},[_c('h4',[_vm._v(_vm._s(_vm.proxima_etapa.dataDia)+"/"+_vm._s(_vm.proxima_etapa.dataMes))]),_c('p',[_vm._v(_vm._s(_vm.proxima_etapa.circuito))]),_c('span',[_vm._v(_vm._s(_vm.proxima_etapa.cidade))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }